import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { Input } from './ui/Input';

interface DeleteObraModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (password: string) => void;
  obraName: string;
  isLoading?: boolean;
}

export const DeleteObraModal: React.FC<DeleteObraModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  obraName,
  isLoading = false,
}) => {
  const [password, setPassword] = useState('');

  const handleConfirmClick = () => {
    onConfirm(password);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirmar Exclusão" size="md">
      <div className="space-y-4">
        <p className="text-sm text-red-400 bg-red-900/50 p-3 rounded-md border border-red-500/50">
          <strong className="block mb-1 text-red-300">Atenção! Ação Irreversível!</strong>
          Você está prestes a excluir permanentemente a obra{' '}
          <strong className="text-white">"{obraName}"</strong>.
          <br />
          Todos os lançamentos de custos associados a esta obra também serão apagados.
        </p>
        <p className="text-sm text-dark-text-secondary">
          Para confirmar esta ação, por favor, digite sua senha de administrador abaixo.
        </p>
        <Input
          id="delete-confirm-password"
          label="Sua Senha"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoFocus
        />
        <div className="flex justify-end space-x-3 pt-4 border-t border-dark-tertiary mt-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={handleConfirmClick}
            disabled={!password || isLoading}
            isLoading={isLoading}
          >
            {isLoading ? 'Excluindo...' : 'Excluir Permanentemente'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};